export const adminCategories = [
  // User and Access Management
  // {
  //   title: 'User and Access Management',
  //   subcategories: [
  //     { text: 'Groups', link: '/admin/groups/' },
  //     { text: 'User Accounts', link: '/admin/users' },
  //     { text: 'Local User Invites', link: '/admin/users/invites' },
  //     // { text: "Roles and Permissions", link: "/admin/users/roles-permissions" },
  //     // { text: "Access Logs", link: "/admin/access-logs" },
  //   ],
  // },
  {
    title: 'Workforce Management',
    subcategories: [
      { text: 'Skilling Sheet', link: '/admin/workforce/skilling-sheet' },
    ],
  },
];
